import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    title = "Flash Insurance Portal";

    constructor(private translate: TranslateService) {}

    ngOnInit(): void {
        this.translate.use(this.translate.getBrowserLang());
    }
}
